/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserProfileResponse } from '../../models/user-profile-response';

export interface GetLoggedInUserDetails$Params {
}

export function getLoggedInUserDetails(http: HttpClient, rootUrl: string, params?: GetLoggedInUserDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileResponse>> {
  const rb = new RequestBuilder(rootUrl, getLoggedInUserDetails.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserProfileResponse>;
    })
  );
}

getLoggedInUserDetails.PATH = '/api/v1/users/me';
